import { LoadingOutlined } from '@ant-design/icons'

import { pick } from '@eastcoal/common/utils/object'

import { AttachmentItem } from '../Item'
import { useAttachmentCardStore } from '../Store/hooks/useStore'

export const AttachmentLoading = () => {
  const { filename } = useAttachmentCardStore(state =>
    pick(state, ['filename'])
  )

  return <AttachmentItem filename={filename} icon={<LoadingOutlined />} />
}
